export const TeamA = "TeamA";
export const TeamB = "TeamB";
export const OVERVIEW = "OverView";
export const AUCTION = "Auction";
export const TEAMS = "Teams";
export const PLAYERS = "Players";
export const MATCHES = "Matches";
export const POINTSTABLE = "PointsTable";
export const LEADERBOARD = "LeaderBoard";
export const SPONSORS = "Sponsors";
export const ALL = "All";
export const HOSTING = "Hosting";
export const PLAYING = "Playing";
export const FOLLOWING = "Following";
export const FILTER = "Filter";
